/**
 * Pushes the current bearer token to the active service worker so its cached
 * chunked-attachment entries always carry a live token.
 *
 * Why this exists: the SW captures a one-shot token snapshot at REGISTER_CSK and
 * has no other way to learn about the app's silent token refresh. A long-running
 * transfer — especially the background prefetch loop, which no mounted component
 * can re-register — would otherwise 401 the moment that original JWT expires.
 * The SW handles the `UPDATE_TOKEN` message by updating every cached entry.
 */
export function postTokenToServiceWorker(token: string | undefined): void {
  if (!token) {
    return;
  }
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }
  // Only the controlling SW serves /sw-stream; if nothing controls the page yet
  // there are no cached entries to refresh, so dropping the message is fine.
  navigator.serviceWorker.controller?.postMessage({
    type: "UPDATE_TOKEN",
    token,
  });
}
